import {
  Avatar,
  Card,
  Flex,
  Group,
  Image,
  Stack,
  Text,
  Container,
  Box
} from '@mantine/core';
import React from 'react';
import { Link } from 'react-router-dom';
import { Carousel } from '@mantine/carousel';
import styles from './styles.module.scss';
import { useMediaQuery } from '@mantine/hooks';
import NoData from '../../../../assets/icon/illustrations_no-document.svg';
import Button from '../../../elements/Button';
import IllustrationState from '../../IllustrationState';
import { IMG_MYSTERYMAN } from '../../../c_avatar/Avatar.const';
import { getSharepointCdnFile } from '../../../../utilities';
import { highlightText } from '../../../../utilities/highlightText';

interface ModalInterestProps {
  section: any;
  isSearch?: boolean;
  isCarousel?: boolean;
  querysearch?: string;
}

export default function CaseStudySection({
  section,
  isSearch,
  isCarousel,
  querysearch
}: ModalInterestProps) {
  const xsScreen = useMediaQuery('(max-width: 30em)');
  const smScreen = useMediaQuery('(max-width: 48em)');
  const mdScreen = useMediaQuery('(max-width: 64em)');
  const lgScreen = useMediaQuery('(max-width: 74em)');
  const size =
    smScreen || mdScreen
      ? (100 / 2).toString()
      : lgScreen
      ? (100 / 2).toString()
      : (100 / 3).toString();
  const slidesScroll = xsScreen ? 1 : smScreen || mdScreen ? 2 : 3;
  return (
    <Box component="div" bg={section.backgroundColor ?? ''}>
      <Container size={'xl'} px={0}>
        <Group align="center" justify="space-between">
          <Stack gap={0}>
            <Text fz={20} fw={700}>
              {section.title ?? 'Case Study'}
            </Text>
            <Text fz={14} fw={500} c={'gray'}>
              {isSearch
                ? section.contents?.length + ' Results'
                : section.subtitle ?? ''}
            </Text>
          </Stack>
          {section.contents?.length > 4 && (
            <Button variant="link" linkTo={`/snfm/overview`}>
              View All
            </Button>
          )}
        </Group>
        {section?.contents?.length === 0 && (
          <IllustrationState
            isIlustration={false}
            Illustration={<Image src={NoData} w={'50%'} />}
            description="No result found"
          />
        )}
        {section?.contents?.length > 0 && (
          <Carousel
            withIndicators={section?.contents?.length > 4 ? true : false}
            withControls={section?.contents?.length > 4 ? true : false}
            classNames={styles}
            loop
            align="start"
            slideSize={{ base: '100%', sm: size + '%' }}
            slideGap={{ base: 0, sm: smScreen || mdScreen ? 'sm' : 'lg' }}
            slidesToScroll={slidesScroll}
            py={12}
            mb={10}
          >
            {section?.contents?.map((item, index: number) => {
              return (
                <Carousel.Slide key={index}>
                  <Link
                    to={`/snfm/case-study/detail/${item.contentId}`}
                    style={{
                      textDecoration: 'none'
                    }}
                  >
                    <Card shadow="sm" padding="lg" radius="lg" withBorder>
                      <Text
                        fz={16}
                        fw={700}
                        style={{
                          minHeight: '50px'
                        }}
                      >
                        {item.title.length > 50
                          ? querysearch
                            ? highlightText(
                                item.title.substring(0, 50) + '...',
                                querysearch
                              )
                            : item.title.substring(0, 50) + '...'
                          : querysearch
                          ? highlightText(item.title, querysearch)
                          : item.title}
                      </Text>

                      <Text
                        fz={14}
                        fw={500}
                        mt={10}
                        lineClamp={3}
                        style={{
                          height: '80px'
                        }}
                      >
                        <div
                          dangerouslySetInnerHTML={{
                            __html:
                              item?.shortDescription?.length > 100
                                ? item?.shortDescription?.substring(0, 100) +
                                  '...'
                                : item?.shortDescription
                          }}
                        />
                      </Text>
                      <Flex align={'center'}>
                        <Avatar
                          mr={10}
                          size={40}
                          radius={20}
                          src={
                            item.isAnonim === 'Y'
                              ? IMG_MYSTERYMAN
                              : item.fotoUser
                              ? getSharepointCdnFile(item.fotoUser)
                              : IMG_MYSTERYMAN ||
                                'https://via.placeholder.com/150'
                          }
                        />
                        <div>
                          <Text fz={12} fw={700} truncate="end">
                            {item.isAnonim === 'Y'
                              ? 'Binusian'
                              : item.name ?? 'Unknown'}
                          </Text>
                          <Text fz={12} fw={500} c={'gray'} truncate="end">
                            {item.unit}
                          </Text>
                        </div>
                      </Flex>
                    </Card>
                  </Link>
                </Carousel.Slide>
              );
            })}
          </Carousel>
        )}
      </Container>
    </Box>
  );
}
